import { injectable, provided } from "inversify-sugar";
import * as IOrderRepository from "../business/IOrderRepository";
@injectable()
export default class OrderUseCase {
  @provided(IOrderRepository.IOrderRepositoryToken)
  private orderRepository!: IOrderRepository.IOrderRepository;

  public getUnits() {
    return this.orderRepository.getUnits();
  }

  public getVehicleTypes(query: any) {
    return this.orderRepository.getVehicleTypes(query);
  }

  public updateVehicleType(vehicleTypeId: number, allowBid: boolean) {
    return this.orderRepository.updateVehicleType({ vehicleTypeId, allowBid });
  }

  public getAllPickupLocations() {
    return this.orderRepository.getAllPickupLocations();
  }

  public getAllOrders(status?: string, page?: number, input?: string, filter?: string) {
    return this.orderRepository.getAllOrders(status, page, input, filter);
  }

  public getBidHistory() {
    return this.orderRepository.getBidHistory();
  }

  public getPaidBidCancel(page: number, input: string, filter: string) {
    return this.orderRepository.getPaidBidCancel(page, input, filter);
  }

  public rebid(values: any) {
    return this.orderRepository.rebid(values);
  }

  public getAllDeliveryLocations() {
    return this.orderRepository.getAllDeliveryLocations();
  }

  public getOrderDetail(id: any, deletePrev?: boolean) {
    return this.orderRepository.getOrderDetail(id, deletePrev);
  }

  public getBidRequests(id: any) {
    return this.orderRepository.getBidRequests(id);
  }

  public updateOrder(id: any, values: any) {
    return this.orderRepository.updateOrder(id, values);
  }

  public orderCancelShipper(id: any, values: any) {
    return this.orderRepository.orderCancelShipper(id, values);
  }
  public placeOrder(values: any, action?: string) {
    return this.orderRepository.placeOrder(values, action);
  }

  public getShipperBids = () => {
    return this.orderRepository.getShipperBids();
  };

  public putSubmitOrder = (values: any, orderId: number) => {
    return this.orderRepository.putSubmitOrder(values, orderId);
  };

  public shipperAcceptBids = (bidId: number) => {
    return this.orderRepository.shipperAcceptBids(bidId);
  };

  public getCoords = (values: any) => {
    return this.orderRepository.getCoords(values);
  };

  public getDigitalContractWithBidRequest(id: any) {
    return this.orderRepository.getDigitalContractWithBidRequest(id);
  }

  public acknowledgeDigitalContract(values: any) {
    return this.orderRepository.acknowledgeDigitalContract(values);
  }

  public updateDraftOrder(id: any, values: any) {
    return this.orderRepository.updateDraftOrder(id, values);
  }

  public cancelRequestShipper(orderNumber: any, values: any) {
    return this.orderRepository.cancelRequestShipper(orderNumber, values);
  }

  public getNewRequest(page?: number) {
    return this.orderRepository.getNewRequest(page);
  }

  public getAcceptedRequest(page?: number) {
    return this.orderRepository.getAcceptedRequest(page);
  }

  public updateRequestAndOrder(vehicleSpecificationId: number, values: { offerPrice: string; contractRate: string; remarks: string }) {
    return this.orderRepository.updateRequestAndOrder(vehicleSpecificationId, values);
  }

  public getRequestAndOrder(status?: string, page?: number, input?: string, filter?: string) {
    return this.orderRepository.getRequestAndOrder(status, page, input, filter);
  }

  public getBidList(vehicleSpecId: number) {
    return this.orderRepository.getBidList(vehicleSpecId);
  }

  public cancelOrder = (orderId: number) => {
    console.log("here in oprder moduke container");
    return this.orderRepository.cancelOrder(orderId);
  };

  public extendExpiry = (id: number) => {
    return this.orderRepository.extendExpiry(id);
  };

  // Transaction Policy
  public getTransactionPolicy() {
    return this.orderRepository.getTransactionPolicy();
  }

  public updateTransactionPolicy(policyId: number, values: { timeBeforePickup: string; refundPercentage: number }) {
    return this.orderRepository.updateTransactionPolicy(policyId, values);
  }

  // Get applicable policy for cancellation
  public getApplicablePolicy(vehicleSpecificationId: number) {
    return this.orderRepository.getApplicablePolicy(vehicleSpecificationId);
  }

  public getRefundRequests(page?: number, input?: string, filter?: string) {
    return this.orderRepository.getRefundRequests(page, input, filter);
  }

  public acceptRefundRequest(id: number | number[]) {
    return this.orderRepository.acceptRefundRequest(id);
  }

  public rejectRefundRequest(id: number, declinedReason: string) {
    return this.orderRepository.rejectRefundRequest(id, declinedReason);
  }

  public completeRefundRequest(id: number) {
    return this.orderRepository.completeRefundRequest(id);
  }

  public submitRefundRequest(data: { documentId: number; additionalDetails: string; refundIds: number[] }) {
    return this.orderRepository.submitRefundRequest(data);
  }

  // Subscription Policy
  public getSubscriptionPolicy() {
    return this.orderRepository.getSubscriptionPolicy();
  }

  public updateSubscriptionPolicy(policyId: number, values: { timeBeforeExpiry: string; refundPercentage: number }) {
    return this.orderRepository.updateSubscriptionPolicy(policyId, values);
  }
  public getSubscriptionRefundRequests(page?: number, input?: string, filter?: string) {
    return this.orderRepository.getSubscriptionRefundRequests(page, input, filter);
  }
  public accepSubscriptionRefundRequest(id: number | number[]) {
    return this.orderRepository.accepSubscriptionRefundRequest(id);
  }

  public updateRuleStatus(title: string, isActive: boolean) {
    return this.orderRepository.updateRuleStatus(title, isActive);
  }

  public getRuleStatus() {
    return this.orderRepository.getRuleStatus();
  }
}
